import {LoginDto, SignUpDto, checkDuplicateUserIdDto, NaverLoginDto} from '@/services/LoginModels';
import AXIOS from '@/services/axios-wrapper';
import {User, UserIdFind} from '@/models';

class LoginService {
  constructor() {
    console.log('creating new instance of LoginService');
  }

  guestLogin() {
    return AXIOS.post(`guestLogin`);
  }
  memberCorpLogin() {
    return AXIOS.post(`memberCorpLogin`);
  }

  login(loginDto: LoginDto) {
    return AXIOS.post(`login`, loginDto);
  }

  logout() {
    return AXIOS.post(`logout`);
  }

  refreshToken() {
    return AXIOS.post(`userRefreshToken`);
  }

  checkDuplicateId(userIdDto: checkDuplicateUserIdDto) {
    return AXIOS.post(`checkDuplicateId`, userIdDto);
  }

  userJoin(signUpDto: SignUpDto) {
    return AXIOS.post(`userJoin`, signUpDto);
  }

  naverLogin(naverLoginDto: NaverLoginDto) {
    return AXIOS.post(`naverLogin`, naverLoginDto);
  }

  kakaoLogin(kakaoLoginDto: NaverLoginDto) {
    return AXIOS.post(`kakaoLogin`, kakaoLoginDto);
  }

  getBizSirenEncode(retUrl?: string) {
    return AXIOS.get(`getBizSirenEncode`, {
      params: retUrl ? {retUrl} : {},
    });
  }

  getBizSirenPhoneDecode(type: string, retInfo: string) {
    return AXIOS.get(`getBizSirenPhoneDecode/` + type + `/` + retInfo);
  }

  getBizSirenPhoneDecodeV4(type: string, cryptoTokenId: string, integrityValue?: string) {
    return AXIOS.get(`getBizSirenPhoneDecode/` + type, {
      params: {
        crypto_token_id: cryptoTokenId,
        integrity_value: integrityValue,
      },
    });
  }

  getBizSirenEncodeIpin() {
    return AXIOS.get(`getBizSirenEncodeIpin`);
  }

  getBizSirenIpinDecode(retInfo: string) {
    return AXIOS.get(`getBizSirenIpinDecode/` + retInfo);
  }

  userIdFind(user: User) {
    return AXIOS.post(`userIdFind`, user);
  }

  UserNameHpCheck(user: User) {
    return AXIOS.post(`UserNameHpCheck`, user);
  }

  userIdFindMissing(user: UserIdFind) {
    return AXIOS.post(`userIdFindMissing`, user);
  }

  userLeave(user: User, userId: string) {
    return AXIOS.post(`userLeave/` + userId, user);
  }

  userMyInfo() {
    return AXIOS.post(`MyInfo`);
  }

  userPWCheck(user: User, userPassword: string) {
    const postData = {
      userDto: user,
      userPassword: userPassword,
    };
    return AXIOS.post(`PWCheck`, postData);
  }

  userMyInfoChange(user: User, newUserInfo: SignUpDto) {
    const url = `MyInfoChange`;
    return AXIOS.post(url, newUserInfo);
  }

  userPwChange(user: User, oldPassword: string, newPassword: string) {
    const postData = {
      userDto: user,
      oldPassword: oldPassword,
      newPassword: newPassword,
    };
    const url = `UserPwChange`;
    return AXIOS.post(url, postData);
  }

  userPwChangeNologin(userId: string, retInfo: string, newPassword: string) {
    const postData = {
      newPassword: newPassword,
      retInfo: retInfo,
      userId: userId,
    };
    const url = `UserPwChangeNologin`;
    return AXIOS.post(url, postData);
  }

  snsUserLeave(userId: string, snsId: string) {
    const url = `SnsUserLeave/` + userId + '/' + snsId;
    return AXIOS.post(url);
  }

  sendEmailAuthCode(toEmail: string) {
    return AXIOS.get(`SendEmailAuthCode/` + toEmail);
  }

  sendEmailAuthCodeEng(toEmail: string) {
    return AXIOS.get(`SendEmailAuthCodeEng/` + toEmail);
  }

  checkEmailAuthCode(authCode: string) {
    return AXIOS.get(`CheckEmailAuthCode/` + authCode);
  }
  marketingAgreementUpdate(
    guestNo: string,
    opinionYn: string,
    prsinClctn01: string,
    prsinClctn02: string,
    prsinClctn03: string,
    marketingYn: string,
    smsSendYn: string,
  ) {
    const postData = {
      guestNo: guestNo,
      opinionYn: opinionYn,
      prsinClctn01: prsinClctn01,
      prsinClctn02: prsinClctn02,
      prsinClctn03: prsinClctn03,
      marketingYn: marketingYn,
      smsSendYn: smsSendYn,
    };
    const url = `/com/MarketingAgreementUpdate`;
    return AXIOS.post(url, postData);
  }
}

// Export a singleton instance in the global namespace
export const loginService = new LoginService();
